import React from 'react';
import { ArrowRight } from 'lucide-react';
import { VALUATION_INPUT_CLS, VALUATION_BUTTON_CLS, VALUATION_BUTTON_STYLE } from './styles';

export const ValuationStepAddress = ({ address, onChange, suffix = '' }) => (
  <>
    <div className="text-center pb-2" data-testid={`valuation-step-1${suffix}`}>
      <p className="text-sm font-semibold text-[#143160] uppercase tracking-wider">Step 1 of 2 · 30 seconds</p>
      <p className="text-xs text-gray-500 mt-1">Start with just your address — no commitment</p>
    </div>
    <input
      data-testid={`valuation-address${suffix}`}
      aria-label="Property address"
      className={VALUATION_INPUT_CLS}
      placeholder="Property Address (e.g., 123 Main St)*"
      required
      autoComplete="street-address"
      value={address}
      onChange={(e) => onChange(e.target.value)}
    />
    <button
      data-testid={`valuation-next${suffix}`}
      type="submit"
      disabled={!address.trim()}
      className={`${VALUATION_BUTTON_CLS} disabled:opacity-60 disabled:cursor-not-allowed`}
      style={VALUATION_BUTTON_STYLE}
    >
      <span className="relative flex items-center justify-center">
        Get My Free Valuation
        <ArrowRight className="w-6 h-6 ml-2 text-gold-400" />
      </span>
    </button>
    <p className="text-xs text-center text-gray-500 font-medium">🔒 No spam · No obligation · 100% free</p>
  </>
);
